import styles from "../Editor.module.css";
import InputControl from "../../InputControl/InputControl";

const EducationBody = (props) => {
    const sections = props.sections;
  return (
    <div className={styles.detail}>
    <div className={styles.row}>
      <InputControl
        label="Title"
        value={props.information[sections.education].details[props.activeDetailIndex]?.title}
        placeholder="Enter title eg. B-tech"
        onChange={(event) =>
          props.setInformation((prev) => ({ ...prev, 
              [sections.education]: {...prev[sections.education],
                details: prev[sections.education].details.map((detail, index) =>
                    index === props.activeDetailIndex? { ...detail, title: event.target.value } : detail 
                )  
              }
          }))
        }
      />
    </div>
    <InputControl
      label="College/School Name"
      value={props.information[sections.education].details[props.activeDetailIndex]?.college}
      placeholder="Enter name of your college/school"
      onChange={(event) =>
          props.setInformation((prev) => ({ ...prev, 
              [sections.education]: {...prev[sections.education],
                details: prev[sections.education].details.map((detail, index) =>
                  index === props.activeDetailIndex? { ...detail, college: event.target.value } : detail 
                ) 
              }
          }))
      }
    />
    <div className={styles.row}>
      <InputControl
        label="Start Date"
        type="date"
        placeholder="Enter start date of this education"
        value={props.information[sections.education].details[props.activeDetailIndex]?.startDate}
        onChange={(event) =>
          props.setInformation((prev) => ({ ...prev, 
              [sections.education]: {...prev[sections.education],
                details: prev[sections.education].details.map((detail, index) =>
                  index === props.activeDetailIndex? { ...detail, startDate: event.target.value } : detail 
                ) 
              }
          }))
        }
      />
      <InputControl
        label="End Date"
        type="date"
        placeholder="Enter end date of this education"
        value={props.information[sections.education].details[props.activeDetailIndex]?.endDate}
        onChange={(event) =>
          props.setInformation((prev) => ({ ...prev, 
              [sections.education]: {...prev[sections.education],
                details: prev[sections.education].details.map((detail, index) =>
                  index === props.activeDetailIndex? { ...detail, endDate: event.target.value } : detail 
                ) 
              }
          }))
        }
      />
      <InputControl
        label="Result"
        style={{width:'175px'}}
        placeholder="CGPA/Percent"
        value={props.information[sections.education].details[props.activeDetailIndex]?.result}
        onChange={(event) =>
          props.setInformation((prev) => ({ ...prev, 
              [sections.education]: {...prev[sections.education],
                details: prev[sections.education].details.map((detail, index) =>
                  index === props.activeDetailIndex? { ...detail, result: event.target.value } : detail 
                ) 
              }
          }))
        }
      />
    </div>
  </div>
  )
}

export default EducationBody